import React from 'react';
import { Link } from 'react-router-dom';
import config from '@/configs/config';
import './footer.css';
import footer_fbicon from './footer_fbicon.png';
import footer_lineicon from './footer_lineicon.png';
import footer_igicon from './footer_igicon.png';

export default () => (
  <div className={`
    ${config.themeBackgroundColor ? `md:fz-bg-[${config.themeBackgroundColor}]` : 'md:fz-bg-black'}
    fz-hidden
    md:fz-block
    fz-py-8
  `}
  >
    <div className="fz-container fz-m-auto">
      <div className="fz-flex fz-justify-between fz-items-start">
        <Link to="/"><img alt="" width="100px" src={`${config.RESOURCE_URI}footer_logo.png`} /></Link>
        <div className="fz-flex fz-items-center fz-gap-x-3">
          { config.modules?.partner_residential === false
            ? null
            : <Link className="wf_footer_item" to="/partner_residential">社區合作方案</Link>}
          { config.modules?.partner_location === false
            ? null
            : <Link className="wf_footer_item" to="/partner_location">場域進駐方案</Link>}
          { config.modules?.partner_provider === false
            ? null
            : <Link className="wf_footer_item" to="/partner_provider">成為餐食夥伴</Link>}
          { config.modules?.partner_saas_pro === false
            ? null
            : <Link className="wf_footer_item" to="/partner_saas_pro">客製品牌門市</Link>}
          { config.modules?.faq === false
            ? null
            : <Link className="wf_footer_item" to="/faq">常見問與答</Link>}
          <a target="_blank" rel="noopener noreferrer" href={config.linkLine}>
            <img alt="" className="icon line" src={footer_lineicon} />
          </a>
          <a target="_blank" rel="noopener noreferrer" href={config.linkIg}>
            <img alt="" className="icon ig" src={footer_igicon} />
          </a>
          <a target="_blank" rel="noopener noreferrer" href={config.linkFb}>
            <img alt="" className="icon fb" src={footer_fbicon} />
          </a>
        </div>
      </div>
      <div className="fz-text-sm fz-text-white fz-text-right">
        {config.copyrightDisclaimer || ''}
      </div>
    </div>
  </div>
);
